<div class="ui-date-picker-calendar-header">
  <button
    type="button"
    class="ui-date-picker-calendar-header__title typography-labels-2"
    (click)="switchView()"
  >
    <span>{{ periodLabel | uppercase }}</span>

    <fr8bot-ui-icon
      [name]="calendar.currentView === 'month' ? 'arrow-down-12' : 'arrow-up-12'"
      [size]="16"
    />
  </button>

  <div class="ui-date-picker-calendar-header__switches">
    <button type="button" aria-label="Previous" (click)="moveDate(-1)">
      <fr8bot-ui-icon name="arrow-left-12" [size]="16" />
    </button>

    <button type="button" aria-label="Next" (click)="moveDate(1)">
      <fr8bot-ui-icon name="arrow-right-12" [size]="16" />
    </button>
  </div>
</div>
